module.exports = __webpack_public_path__ + "static/img/12jujueshuliao.b95fc918.gif";